import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';



function * indexShortCodesAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/shortCodes')
     yield put({type:'REQUEST_INDEX_SHORT_CODES_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getShortCodeAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/shortCodes/'+data.id, data.payload)
     yield put({type:'REQUEST_GET_SHORT_CODE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * createShortCodeAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/shortCodes', data.payload)
     yield put({type:'REQUEST_CREATE_SHORT_CODE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateShortCodeAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/shortCodes/'+data.id, data.payload)
     yield put({type:'REQUEST_UPDATE_SHORT_CODE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteShortCodeAsync(data){
  try{
     const api = yield call([axios, axios.delete], '/api/shortCodes/'+data.id)
     yield put({type:'REQUEST_DELETE_SHORT_CODE_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * cloneShortCodeAsync(data){
  try{
     let url='/api/shortCodes/clone/'+data.id;
     const api = yield call([axios, axios.post], url)
     yield put({type:'REQUEST_CLONE_SHORT_CODE_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}





function * cloneHtmlTemplateAsync(data){
  try{
     let url='/api/htmlTemplates/clone/'+data.id;
     const api = yield call([axios, axios.post], url)
     yield put({type:'REQUEST_CLONE_HTML_TEMPLATE_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteHtmlTemplateAsync(data){
  try{
     let url='/api/htmlTemplates/'+data.id;
     const api = yield call([axios, axios.delete], url)
     yield put({type:'REQUEST_DELETE_HTML_TEMPLATE_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getHtmlTemplateAsync(data){
  try{
     let url='/api/htmlTemplates/'+data.id; //if(data.with_trashed==true){url=url+'?with_trashed=true';}
     const api = yield call([axios, axios.get], url)
     yield put({type:'REQUEST_GET_HTML_TEMPLATE_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getHtmlTemplateInstanceAsync(data){
  try{
     let url='/api/htmlTemplateInstances/'+data.id;
     const api = yield call([axios, axios.get], url)
     yield put({type:'REQUEST_GET_HTML_TEMPLATE_INSTANCE_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * indexHtmlTemplatesAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/htmlTemplates')
     yield put({type:'REQUEST_INDEX_HTML_TEMPLATES_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * createHtmlTemplateAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/htmlTemplates', data.payload)
    yield put({type:'REQUEST_CREATE_HTML_TEMPLATE_SUCCESS', val:api.data});
    yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    if(error.response.data!=undefined && error.response.data.error=='gmail_permission_required'){yield put({type:'GMAIL_UNAUTHORISED', val:api.data});}
    else{yield put({type:'REQUEST_FORM_ERROR', val:error.response})}
  }
}

function * updateHtmlTemplateAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/htmlTemplates/'+data.id, data.payload)
     yield put({type:'REQUEST_UPDATE_HTML_TEMPLATE_SUCCESS', val:api.data});
     yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}


function * indexEmailSequencesAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/email/sequences')
     yield put({type:'REQUEST_INDEX_EMAIL_SEQUENCES_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * createEmailSequenceAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/email/sequences', data.payload)
     yield put({type:'REQUEST_CREATE_EMAIL_SEQUENCE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateEmailSequenceAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/email/sequences/'+data.id, data.payload)
     yield put({type:'REQUEST_UPDATE_EMAIL_SEQUENCE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * cloneEmailSequenceAsync(data){
  try{
     let url='/api/email/sequences/clone/'+data.id;
     const api = yield call([axios, axios.post], url)
     yield put({type:'REQUEST_CLONE_EMAIL_SEQUENCE_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteEmailSequenceAsync(data){
  try{
     let url='/api/email/sequences/'+data.id;
     const api = yield call([axios, axios.delete], url)
     yield put({type:'REQUEST_DELETE_EMAIL_SEQUENCE_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function* Index_short_codes(){yield takeEvery('REQUEST_INDEX_SHORT_CODES', indexShortCodesAsync);}
function* Get_short_code(){yield takeEvery('REQUEST_GET_SHORT_CODE', getShortCodeAsync);}
function* Create_short_code(){yield takeEvery('REQUEST_CREATE_SHORT_CODE', createShortCodeAsync);}
function* Update_short_code(){yield takeEvery('REQUEST_UPDATE_SHORT_CODE', updateShortCodeAsync);}
function* Delete_short_code(){yield takeEvery('REQUEST_DELETE_SHORT_CODE', deleteShortCodeAsync);}
function* Clone_short_code(){yield takeEvery('REQUEST_CLONE_SHORT_CODE', cloneShortCodeAsync);}

function* Get_html_template_instance(){yield takeEvery('REQUEST_GET_HTML_TEMPLATE_INSTANCE', getHtmlTemplateInstanceAsync);}

function* Get_html_template(){   yield takeEvery('REQUEST_GET_HTML_TEMPLATE', getHtmlTemplateAsync);}
function* Delete_html_template(){   yield takeEvery('REQUEST_DELETE_HTML_TEMPLATE', deleteHtmlTemplateAsync);}
function* Index_html_templates(){yield takeEvery('REQUEST_INDEX_HTML_TEMPLATES', indexHtmlTemplatesAsync);}
function* Create_html_template(){yield takeEvery('REQUEST_CREATE_HTML_TEMPLATE', createHtmlTemplateAsync);}
function* Update_html_template(){yield takeEvery('REQUEST_UPDATE_HTML_TEMPLATE', updateHtmlTemplateAsync);}
function* Clone_html_template(){yield takeEvery('REQUEST_CLONE_HTML_TEMPLATE', cloneHtmlTemplateAsync);}

function* Index_email_sequences(){yield takeEvery('REQUEST_INDEX_EMAIL_SEQUENCES', indexEmailSequencesAsync);}
function* Create_email_sequence(){yield takeEvery('REQUEST_CREATE_EMAIL_SEQUENCE', createEmailSequenceAsync);}
function* Update_email_sequence(){yield takeEvery('REQUEST_UPDATE_EMAIL_SEQUENCE', updateEmailSequenceAsync);}
function* Clone_email_sequence(){yield takeEvery('REQUEST_CLONE_EMAIL_SEQUENCE', cloneEmailSequenceAsync);}
function* Delete_email_sequence(){yield takeEvery('REQUEST_DELETE_EMAIL_SEQUENCE', deleteEmailSequenceAsync);}


export default function* Root_templates(){
  yield all([
    fork(Delete_short_code),
    fork(Index_short_codes),
    fork(Get_short_code),
    fork(Create_short_code),
    fork(Update_short_code),
    fork(Clone_short_code),
    fork(Get_html_template_instance),
    fork(Get_html_template),
    fork(Delete_html_template),
    fork(Index_html_templates),
    fork(Create_html_template),
    fork(Update_html_template),
    fork(Clone_html_template),
    fork(Index_email_sequences),
    fork(Create_email_sequence),
    fork(Update_email_sequence),
    fork(Delete_email_sequence),
    fork(Clone_email_sequence),
    fork(Delete_email_sequence)
  ])}
